// src/components/layout/Header.js
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Container,
  Offcanvas,
  Form,
  Button,
  Nav,
  Navbar,
  NavDropdown,
  Modal,
} from "react-bootstrap";
import { useNavigate, Link, NavLink } from "react-router-dom";
import { useAuth } from "../../shared/auth/AuthProvider";
import "../styles/Header.css";

import { BsSearch, BsChevronRight } from "react-icons/bs";

import logo_header_01 from "../../assets/logo_header_01.png";
import Logo_Header_02 from "../../assets/Logo_Encraft_02.png";

import chicchic_logo_header01 from "../../assets/chicchic_logo_header01.png";
import chicchic_login_logo from "../../assets/chicchic_login_logo.png";
import chicchic_logo_darkmode from "../../assets/chicchic_logo_darkmode.png";
 
/* function Avatar({ user, profile, size = 36 }) {
  const initial = (
    user?.displayName?.trim()?.[0] ??
    user?.email?.trim()?.[0] ??
    "U"
  ).toUpperCase();

  if (user?.photoURL) { */
  function Avatar({ user, profile, size = 36 }) {
    const photoURL = profile?.photoURL || user?.photoURL || "";
    const initial = (
      profile?.displayName?.trim()?.[0] ??
      user?.displayName?.trim()?.[0] ??
      user?.email?.trim()?.[0] ??
      "U"
    ).toUpperCase();

    if (photoURL) {
      return (
        <img
          // src={user.photoURL}
          src={photoURL}
          alt="profile"
          width={size}
          height={size}
          style={{
            borderRadius: "50%",
            objectFit: "cover",
            display: "block",
          }}
        />
      );
  }

  return (
    <div
      aria-label="profile-initial"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        lineHeight: 1,
        fontSize: size * 0.5,
        background: "#e9ecef",
        color: "#212529",
        fontWeight: 600,
        fontFamily: "Kanit, system-ui, -apple-system, Segoe UI, Roboto",
        userSelect: "none",
      }}
    >
      {initial}
    </div>
  );
}

function Header() {
  const navigate = useNavigate();
  const { user, profile, authLoading, logout } = useAuth();
  const role = profile?.role || "user"; // ค่า default เป็น user

  const [showMyArticleNotlogin, setShowMyArticleNotlogin] = useState(false);
  const handleCloseMyArticleNotlogin = () => setShowMyArticleNotlogin(false);

  const [searchText, setSearchText] = useState("");

  // === คุมการเปิด/ปิด Offcanvas (เมนูมือถือ) ===
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const q = searchText.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const aiSubs = [
    "เนติบัณฑิต",
    "ทนายความ",
    "อัยการ",
    "ผู้พิพากษา",
    "สอบ ก.พ.",
  ];

  return (
    <div>
      <Navbar expand="lg" className="mb-3 header-navbar">
        <Container className="header-container-mobile">
          {/* แถวแรก: โลโก้ + เมนู Toggle */}
          <div className="header-row-top d-flex align-items-center">
            <Navbar.Brand href="/" className="logo-brand">
              <img
                src={chicchic_logo_darkmode}
                width="64"
                height="auto"
                alt="Chicchic Logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle
              className="menu-toggle-mobile d-lg-none ms-auto"
              onClick={() => setShowOffcanvas(true)} // เปิด Offcanvas
            />
          </div>

          {/* แถวที่สอง: ช่องค้นหาเต็มแถว */}
          <Form
            className="header-search-mobile d-lg-none w-100 mt-2"
            onSubmit={handleSearchSubmit}
          >
            <div className="header-search-box-mobile">
              <span className="header-search-icon">
                <BsSearch />
              </span>
              <input
                type="search"
                className="form-control header-search-input"
                placeholder="ค้นหาใน ChicChic"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                enterKeyHint="search"   // ⭐ ปุ่ม Return → Search
              />
            </div>
          </Form>

          <Navbar.Offcanvas
            className="header-offcanvas"
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="end"
            show={showOffcanvas} // ใช้ state
            onHide={() => setShowOffcanvas(false)} // ปิดเมื่อกด X หรือ backdrop
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title
                id={`offcanvasNavbarLabel-expand-lg`}
                style={{ fontFamily: "Kanit" }}
              >
                <Link 
                  to="/"
                  onClick={() => setShowOffcanvas(false)}
                  style={{
                    textDecoration: "none",
                    color: "inherit"  // ทำให้สีเหมือนเดิม
                  }}
                >
                  ChicChic
                </Link>
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="header-offcanvas-body">
              {/* ====== Desktop layout (≥ lg) ====== */}
              <div className="d-none d-lg-flex flex-grow-1 align-items-center">
                {/* เมนูหลัก (desktop) */}
                <Nav className="nav-menu d-flex align-items-center">
                  <NavDropdown
                
                    title="ค้นหา"
                    id="collapsible-nav-dropdown"
                    style={{
                      // color: "black",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontFamily: "Kanit",
                    }}
                  >
                    {aiSubs.map((item) => (
                      <NavDropdown.Item
                        key={item}
                        onClick={() => {
                          window.location.href = `/search?q=${encodeURIComponent(
                            item
                          )}`;
                        }}
                      >
                        {item}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>

                  {/* ช่องค้นหา – version จอใหญ่ */}
                  <Form
                    className="header-search d-none d-md-flex ms-3"
                    onSubmit={handleSearchSubmit}
                  >
                    <div className="header-search-box">
                      <span className="header-search-icon">
                        <BsSearch />
                      </span>
                      <input
                        type="search"
                        className="form-control header-search-input"
                        placeholder="ค้นหาใน ChicChic"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </Form>
                </Nav>

                {/* โปรไฟล์ / ปุ่มล็อกอิน (desktop) */}
                <div className="nav-profile ms-lg-auto d-flex align-items-center mt-2 mt-lg-0">
                  {authLoading ? (
                    <div
                      className="nav-profile-placeholder"
                      aria-hidden="true"
                      style={{ width: 108, height: 38 }}
                    />
                  ) : !user ? (
                    <>
                     {/*  <Nav.Link
                        onClick={() => setShowMyArticleNotlogin(true)}
                        style={{
                          marginRight: 8,
                          color: "black",
                          fontWeight: "bold",
                          fontFamily: "Kanit",
                        }}
                      >
                        <Button
                          className="rounded-0 nav-article-btn"
                          variant="outline-secondary"
                          style={{ color: "black", borderColor: "transparent" }}
                        >
                          <strong>บทความของฉัน</strong>
                        </Button>
                      </Nav.Link> */}

                      {/* <NavLink
                        to="/login"
                        style={{
                          marginRight: 8,
                          color: "black",
                          textDecoration: "none",
                          fontFamily: "Kanit",
                        }}
                      >
                        <Button
                          className="rounded-0 nav-article-btn"
                          variant="outline-secondary"
                          style={{ color: "black" }}
                        >
                          <strong>เข้าสู่ระบบ</strong>
                        </Button>
                      </NavLink>

                      <NavLink
                        to="/register"
                        style={{
                          color: "black",
                          textDecoration: "none",
                          fontFamily: "Kanit",
                        }}
                      >
                        <Button
                          className="rounded-0 nav-article-btn"
                          variant="dark"
                        >
                          <strong>สมัครใหม่</strong>
                        </Button>
                      </NavLink> */}
                      {/* ===== ใหม่: ปุ่มเดียว ===== */}
                      <NavLink
                        to="/login"
                        style={{
                          // color: "black",
                          textDecoration: "none",
                          fontFamily: "Kanit",
                        }}
                      >
                        <Button
                          className="nav-article-btn"
                          variant="dark"
                        >
                          <strong>ลงชื่อเข้าใช้</strong>
                        </Button>
                      </NavLink>
                    </>
                  ) : (
                    <>
                      {/* <Nav.Link
                        as={Link}
                        to="/account/bookmarks"
                        style={{
                          marginRight: 8,
                          color: "black",
                          fontWeight: "bold",
                          fontFamily: "Kanit",
                        }}
                      >
                        <Button
                          className="rounded-0 nav-article-btn"
                          variant="outline-secondary"
                          style={{ color: "black", borderColor: "transparent" }}
                        >
                          <strong>บทความที่บันทึก</strong>
                        </Button>
                      </Nav.Link> */}

                      <NavDropdown
                        align="end"
                        id="nav-profile-dropdown-desktop"
                        className="nav-profile-dropdown"
                        data-bs-display="static"
                        title={
                          <div className="nav-profile-toggle">
                            {/* <Avatar user={user} size={36} /> */}
                            <Avatar user={user} profile={profile} size={36} />
                            <span className="d-none d-lg-inline nav-profile-name">
                              {user.displayName || user.email}
                            </span>
                          </div>
                        }
                      >
                        {/* รายการเมนูพื้นฐาน ทุก role มีเหมือนกัน */}
                        <NavDropdown.Item as={Link} to="/account/profile">
                          โปรไฟล์ของฉัน
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/account/my-courses">
                          คอร์สเรียนของฉัน
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/account/my-course-purchases">
                          การซื้อคอร์สเรียน
                        </NavDropdown.Item>

                        {/* <NavDropdown.Item as={Link} to="/account/bookmarks">
                          บทความที่บันทึก
                        </NavDropdown.Item> */}

                        

                        {/* === creator เท่านั้น === */}
                        {role === "creator" && (
                          <>
                            <NavDropdown.Divider />
                           {/*  <NavDropdown.Item
                              as={Link}
                              to="/account/creator/MyArticle"
                            >
                              บทความของฉัน
                            </NavDropdown.Item> */}
                            
                          </>
                        )}

                        {/* === admin เท่านั้น === */}
                        {role === "admin" && (
                          <>
                           {/*  <NavDropdown.Divider />
                            <NavDropdown.Item
                              as={Link}
                              to="/account/creator/MyArticle"
                            >
                              บทความของฉัน
                            </NavDropdown.Item> */}

                            <NavDropdown.Divider />

                            <NavDropdown.Item
                              as={Link}
                              to="/account/admin/UserInformation"
                            >
                              ข้อมูลผู้ใช้งาน
                            </NavDropdown.Item>

                            
                          </>
                        )}

                        {/* === ปุ่มออกจากระบบ (ทุก role มีเหมือนกัน) === */}
                        {/* <NavDropdown.Divider /> */}
                        {/* <NavDropdown.Item
                          onClick={async () => {
                            try {
                              await logout();
                              navigate("/");
                            } catch (e) {
                              console.error(e);
                            }
                          }}
                        >
                          ออกจากระบบ
                        </NavDropdown.Item> */}
                      </NavDropdown>
                    </>
                  )}
                </div>
              </div>

              {/* ====== Mobile layout (< lg) ====== */}
              <div className="d-lg-none w-100">
                <Nav className="flex-column w-100 nav-menu nav-menu-mobile">
                  <div className="menu-section-label mb-2" style={{fontWeight: "bold"}}>ค้นหาจาก</div>

                  {/* 1) ลิสต์หมวดหมู่จาก aiSubs */}
                  {aiSubs.map((item) => (
                    <Nav.Link
                      key={item}
                      className="navlink-with-arrow py-1"
                      onClick={() => {
                        setShowOffcanvas(false);
                        navigate(`/search?q=${encodeURIComponent(item)}`);
                        // หรือถ้าอยากใช้แบบ reload หน้า:
                        // window.location.href = `/search?q=${encodeURIComponent(item)}`;
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <span>{item}</span>
                        <BsChevronRight size={18} className="text-muted" />
                      </div>
                    </Nav.Link>
                  ))}
                  
                  
                  {/* 2) บทความที่บันทึก / เมนูหลัก */}
                  {!user ? (
                    <>
                    {/* <Nav.Link
                      onClick={() => {
                        setShowMyArticleNotlogin(true);
                        setShowOffcanvas(false); // ปิดเมนูเมื่อกด
                      }}
                      className="mb-1"
                      style={{
                        fontFamily: "Kanit",
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      บทความที่บันทึก
                    </Nav.Link> */}
                    </>
                  ) : (
                    <>
                      <div className="menu-section-label mt-4 mb-2" style={{fontWeight: "bold"}}>บัญชีของฉัน</div>
                      <Nav.Link
                        className="navlink-with-arrow py-1"
                        as={Link}
                        to="/account/profile"
                        onClick={() => setShowOffcanvas(false)}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span>โปรไฟล์ของฉัน</span>
                          <BsChevronRight size={18} className="text-muted" />
                        </div>
                      </Nav.Link>
                      <Nav.Link
                        className="navlink-with-arrow py-1"
                        as={Link}
                        to="/account/my-courses"
                        onClick={() => setShowOffcanvas(false)}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span>คอร์สเรียนของฉัน</span>
                          <BsChevronRight size={18} className="text-muted" />
                        </div>
                      </Nav.Link>
                      <Nav.Link
                        className="navlink-with-arrow py-1"
                        as={Link}
                        to="/account/profile"
                        onClick={() => setShowOffcanvas(false)}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span>การซื้อคอร์สเรียน</span>
                          <BsChevronRight size={18} className="text-muted" />
                        </div>
                      </Nav.Link>

                      {/* <Nav.Link
                        className="navlink-with-arrow py-1"
                        as={Link}
                        to="/account/bookmarks"
                        onClick={() => setShowOffcanvas(false)}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span>บทความที่บันทึก</span>
                          <BsChevronRight size={18} className="text-muted" />
                        </div>
                      </Nav.Link> */}

                      {/* === creator เท่านั้น === */}
                      {/* {(role === "creator" || role === "admin") && (
                        <>

                          <div className="menu-section-label mt-4 mb-2" style={{fontWeight: "bold"}}>ครีเอเตอร์</div>
                          <Nav.Link
                            className="navlink-with-arrow py-1"
                            as={Link}
                            to="/account/creator/MyArticle"
                            onClick={() => setShowOffcanvas(false)}
                          >
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <span>บทความของฉัน</span>
                              <BsChevronRight size={18} className="text-muted" />
                            </div>
                          </Nav.Link>
                          
                        </>
                      )} */}

                      {/* === admin เท่านั้น === */}
                      {role === "admin" && (
                        <>

                          <div className="menu-section-label mt-4 mb-2" style={{fontWeight: "bold"}}>การจัดการ</div>
                          
                          <Nav.Link
                            className="navlink-with-arrow py-1"
                            as={Link}
                            to="/account/admin/UserInformation"
                            onClick={() => setShowOffcanvas(false)}
                          >
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <span>ข้อมูลผู้ใช้งาน</span>
                              <BsChevronRight size={18} className="text-muted" />
                            </div>
                          </Nav.Link>
                        </>
                      )}
                    </>
                  )}

                  {/* 3) ปุ่มโปรไฟล์ */}
                  {/* เส้นคั่น */}
                  <div className="border-top mt-4 w-100">
                    <div className="mt-3">
                      {authLoading ? (
                        <div aria-hidden="true" style={{ minHeight: 54 }} />
                      ) : user ? (
                          <Nav.Link
                            as={Link}
                            to="/account/profile"
                            onClick={() => setShowOffcanvas(false)}
                            className="nav-profile-link mt-3 border-bottom"
                          >
                            <div className="d-flex align-items-center justify-content-between w-100">
                        
                        {/* ซ้าย: avatar + ชื่อ */}
                        <div className="d-flex align-items-center gap-2 mb-4">
                          <Avatar user={user} size={36} />
                          <div className="d-flex flex-column">
                            <span className="fw-semibold" style={{ fontFamily: "Kanit" }}>
                              {user.displayName || user.email}
                            </span>
                            <span
                              className="text-muted"
                              style={{ fontSize: "0.85rem", fontFamily: "Kanit" }}
                            >
                              ดูโปรไฟล์ของฉัน
                            </span>
                          </div>
                        </div>

                        {/* ขวา: ลูกศร */}
                        <BsChevronRight size={20} className="text-muted" />

                      </div>
                          </Nav.Link>
                        ) : (
                          <div className="mt-4 px-1">

                            {/* ข้อความเชิญชวน */}
                            <div 
                              className="mb-2 text-muted"
                              style={{ fontSize: "0.85rem", fontFamily: "Kanit", color: '#0d6efd' }}
                            >
                              เข้าสู่ระบบเพื่อเริ่มเรียนทันที
                            </div>

                            {/* ลิงก์เข้าสู่ระบบ */}
                            {/* <Nav.Link
                              as={Link}
                              to="/login"
                              onClick={() => setShowOffcanvas(false)}
                              className="navlink-with-arrow py-2"
                              style={{ paddingLeft: 0, paddingRight: 0}}
                            >
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span style={{ fontFamily: "Kanit", color: "#007bff" }}>
                                  เข้าสู่ระบบ
                                </span>
                                <BsChevronRight size={18} className="text-muted" />
                              </div>
                            </Nav.Link> */}

                            {/* ลิงก์สมัครสมาชิกใหม่ */}
                            {/* <Nav.Link
                              as={Link}
                              to="/register"
                              onClick={() => setShowOffcanvas(false)}
                              className="navlink-with-arrow py-2 border-bottom"
                              style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span style={{ fontFamily: "Kanit", color: "#ff3b30", paddingBottom: "16px", }}>
                                  สมัครสมาชิกใหม่
                                </span>
                                <BsChevronRight size={18} className="text-muted" />
                              </div>
                            </Nav.Link> */}

                            {/* ===== ใหม่: ปุ่มเดียว ===== */}
                            <Nav.Link
                              as={Link}
                              to="/login"
                              onClick={() => setShowOffcanvas(false)}
                              className="navlink-with-arrow py-2 border-bottom"
                              style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span style={{ fontFamily: "Kanit", color: "#007bff", paddingBottom: "16px" }}>
                                  ลงชื่อเข้าใช้
                                </span>
                                <BsChevronRight size={18} className="text-muted" />
                              </div>
                            </Nav.Link>

                        </div>

                      )}
                    </div>
                  </div>
                </Nav>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

     {/*  <Modal
        show={showMyArticleNotlogin}
        onHide={handleCloseMyArticleNotlogin}
        animation={false}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Link
            to="/login"
            onClick={() => setShowMyArticleNotlogin(false)}
            style={{ textDecoration: "none" }}
          >
            เข้าระบบ
          </Link>{" "}
          หรือ{" "}
          <Link
            to="/register"
            onClick={() => setShowMyArticleNotlogin(false)}
            style={{ textDecoration: "none" }}
          >
            สมัครสมาชิก
          </Link>{" "}
          เพื่อใช้งานบทความของฉัน
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMyArticleNotlogin}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
}

export default Header;

